import React from 'react';
import { FaExclamationTriangle, FaExternalLinkAlt, FaSave, FaSignOutAlt, FaSync, FaUserClock } from 'react-icons/fa';
import { textoAvisoOutroOperador, textoAvisoRascunho } from './rascunhoOrcamentoPolicy';
import '../../css/financeiro-parcela-pagar.css';

// Parte 3 do salvamento automático (Rafael, 16/10 — feita 19/10): enquanto as alterações estão só no
// rascunho, uma faixa na pilha de avisos fixa acima da barra de botões manda clicar em Salvar (sem
// parecer "salvo"); se o envio do rascunho ao servidor falhar, a mesma faixa mostra o erro e quando
// tenta de novo.
export default function AvisoRascunhoOrcamento({ sujo, guardadoEm, erro, salvando, podeSalvar, onSalvar, bloqueio }) {
    const aviso = textoAvisoRascunho({ sujo, guardadoEm, erro, salvando });
    if (!aviso) return null;
    return (
        <div className="fin-pp">
            <div
                className={`fin-pp__banner fin-pp__banner--rodape ${aviso.tom === 'danger' ? 'is-danger' : 'is-warn'}`}
                role={aviso.tom === 'danger' ? 'alert' : 'status'}
                data-testid="aviso-rascunho-orcamento"
            >
                <FaExclamationTriangle size={16} className="fin-pp__banner-ic" />
                <span className="fin-pp__banner-txt">
                    <strong>{aviso.titulo}</strong>
                    {aviso.texto}
                    {/* 20/10: Salvar travado por regra (ex.: evento sem convidados esperados) — a faixa diz o motivo,
                        senão "Clique em Salvar" com o botão desabilitado parece defeito. */}
                    {bloqueio && <strong className="d-block" style={{ marginTop: 2 }} data-bloqueio-salvar>Salvar bloqueado: {bloqueio.texto}</strong>}
                </span>
                {bloqueio && bloqueio.link && (
                    <a className="fin-pp__btn fin-pp__btn--sm" style={{ flex: 'none' }} href={bloqueio.link} target="_blank" rel="noopener noreferrer">
                        <FaExternalLinkAlt size={11} style={{ marginRight: 6 }} />{bloqueio.rotuloLink || 'Abrir'}
                    </a>
                )}
                {aviso.botaoSalvar && !bloqueio && (
                    <button
                        type="button"
                        className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--sm"
                        style={{ flex: 'none' }}
                        onClick={onSalvar}
                        disabled={!podeSalvar}
                    >
                        <FaSave size={13} style={{ marginRight: 6 }} />Salvar
                    </button>
                )}
            </div>
        </div>
    );
}

// D-0052 parte 4a (Rafael, 23/10): outro operador tem alteração não salva neste orçamento. Faixa no
// topo da tela ao abrir; só avisa, não trava a edição.
export function AvisoOutroOperadorOrcamento({ outros }) {
    const aviso = textoAvisoOutroOperador(outros);
    if (!aviso) return null;
    return (
        <div className="fin-pp">
            <div className="fin-pp__banner is-warn" role="status" data-testid="aviso-outro-operador-orcamento" style={{ marginBottom: 8 }}>
                <FaUserClock size={16} className="fin-pp__banner-ic" />
                <span className="fin-pp__banner-txt">
                    <strong>{aviso.titulo}</strong>
                    {aviso.texto}
                </span>
            </div>
        </div>
    );
}

// D-0052 parte 4b (Rafael, 23/10): o Salvar foi recusado (409) porque outra pessoa salvou depois que a
// tela abriu. Fica no lugar do aviso do rascunho, colado nos botões: o Salvar trava e o caminho é
// Recarregar. O que a pessoa digitou continua no rascunho.
export function AvisoConflitoSalvarOrcamento({ conflito, onRecarregar }) {
    if (!conflito) return null;
    return (
        <div className="fin-pp">
            <div className="fin-pp__banner fin-pp__banner--rodape is-danger" role="alert" data-testid="aviso-conflito-salvar-orcamento">
                <FaExclamationTriangle size={16} className="fin-pp__banner-ic" />
                <span className="fin-pp__banner-txt">
                    <strong>Não foi salvo: {conflito.mensagem}</strong>
                    Suas alterações continuam guardadas no rascunho. Ao recarregar, a tela mostra o orçamento salvo e oferece restaurar o seu rascunho.
                </span>
                <button type="button" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--sm" style={{ flex: 'none' }} onClick={onRecarregar}>
                    <FaSync size={12} style={{ marginRight: 6 }} />Recarregar
                </button>
            </div>
        </div>
    );
}

// Saída pela navegação do sistema com alteração não salva: o mesmo aviso, em modal .fin-pp.
// Sem fechar pelo fundo: a pessoa escolhe ficar (e salvar) ou sair sem salvar.
export function ModalSairSemSalvarOrcamento({ aberto, erro, onFicar, onSair }) {
    if (!aberto) return null;
    return (
        <div className="modal fade show d-block fin-pp fin-pp__modalbg" role="dialog" aria-modal="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content fin-pp__modal">
                    <div className="fin-pp__modal-head">
                        <span className="fin-pp__modal-head-ic is-danger"><FaExclamationTriangle size={17} /></span>
                        <h3 className="fin-pp__modal-title">Alterações NÃO salvas
                            <span className="fin-pp__modal-sub">O rascunho não é o orçamento salvo</span>
                        </h3>
                    </div>
                    <div className="modal-body">
                        <p style={{ margin: 0, color: 'var(--fin-tx)', fontSize: 14, lineHeight: 1.5 }}>
                            As alterações deste orçamento <strong>não foram salvas</strong>: estão só no rascunho e
                            não valem no orçamento. Para gravar, fique na tela e clique em <strong>Salvar</strong>.
                        </p>
                        {erro && (
                            <div className="fin-pp__banner is-danger" style={{ marginTop: 14, marginBottom: 0 }}>
                                <FaExclamationTriangle size={15} className="fin-pp__banner-ic" />
                                <span>O último envio do rascunho ao servidor falhou{erro.semConexao ? ' (sem conexão)' : ''}: se sair agora, as alterações podem se perder.</span>
                            </div>
                        )}
                    </div>
                    <div className="fin-pp__modal-foot">
                        <button type="button" className="fin-pp__btn fin-pp__btn--danger-ghost" onClick={onSair}>
                            <FaSignOutAlt size={13} style={{ marginRight: 6 }} />Sair sem salvar
                        </button>
                        <button type="button" className="fin-pp__btn fin-pp__btn--primary" onClick={onFicar}>
                            Ficar e salvar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
